//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import ResponsiveImage from '@/components/modules/ResponsiveImage'

export default {
	components: {
		// ResponsiveImage
	},
	// data() {},
	props: ['data'],
	computed: {},
	mounted() {},
	methods: {}
}

